import { render, staticRenderFns } from "./AquariusStations.vue?vue&type=template&id=366eb61d"
import script from "./AquariusStations.vue?vue&type=script&lang=js"
export * from "./AquariusStations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports